import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Row,
  Col,
} from "reactstrap"
import searchIcon from "../../assets/images/icons/search.svg"
import InvestorSearch from "./components/investorSearch"
import closeIcon from "../../assets/images/icons/close.svg"
import logoLightSvg from "../../assets/images/logo-dark.svg"
import logo from "../../assets/images/logo.svg"
import { Link } from "react-router-dom"

const InvestorSearchModal = ({ open, setOpen }) => {
  const [query, setQuery] = useState("")
  const inputRef = useRef(null)

  const toggle = () => setOpen((prev) => !prev)

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 100)

      return () => clearTimeout(timer)
    }
  }, [open])

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} fullscreen>
        <ModalBody
          style={{
            padding: 0,
            overflowX: "hidden",
          }}
        >
          <Row>
            <Col xl={12}>
              <div
                className="platform-heading-section my-4 d-flex justify-content-between mt-0"
                style={{ background: "#035c98", padding: "5px 20px" }}
              >
                <Link
                  to="#"
                  className="logo logo-dark"
                  onClick={() => setOpen(false)}
                >
                  <span className="logo-sm">
                    <img
                      style={{
                        marginLeft: "18px",
                        marginTop: "5px",
                      }}
                      src={logo}
                      alt=""
                      height="44"
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      style={{
                        marginTop: "10px",
                      }}
                      src={logoLightSvg}
                      alt=""
                      height="35"
                    />
                  </span>
                </Link>
                <div
                  className="top-search-bar"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "10px auto",
                    // maxWidth: "400px",
                  }}
                >
                  <Input
                    type="text"
                    className="form-control search-modal-box-input"
                    placeholder="Search"
                    value={query}
                    innerRef={inputRef}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                  <div className="search">
                    <img src={searchIcon} alt="menuBurger" />
                  </div>
                </div>

                <div onClick={toggle} className="align-self-center">
                  <img className="cp" src={closeIcon} alt="" height={"14px"} />
                </div>
              </div>
            </Col>
          </Row>

          {query && <InvestorSearch query={query} closeModel={toggle} />}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default InvestorSearchModal
